import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { mergeSx } from '@jucy-ui/appearance';
import { BoxProps } from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Link from 'next/link';
import { useRootStore } from '../../hooks/useRootStore';

const LogoComponent: React.FC<BoxProps> = ({ sx, ...props }) => {
    const store = useRootStore();
    const theme = useTheme();
    const version = process.env.NEXT_PUBLIC_APP_VERSION || '';
    return (
        <Box
            {...props}
            sx={mergeSx(
                {
                    display: 'flex',
                    alignItems: 'center',
                },
                sx
            )}
        >
            <Link
                href="/"
                style={{
                    color: theme.palette.secondary.main,
                    display: 'flex',
                    textDecoration: 'none',
                    alignItems: 'center',
                    marginRight: theme.spacing(3),
                }}
                title={`${store.brand === 'jucy' ? 'JUCY' : 'STAR'} Customer Portal${version ? ` - v${version}` : ''}`}
            >
                <Box
                    component="img"
                    src={store.brand === 'jucy' ? '/assets/images/jucy-logo.svg' : '/assets/images/star-logo.svg'}
                    alt={store.brand === 'jucy' ? 'JUCY Rentals' : 'STAR Rentals'}
                    sx={{
                        marginRight: 5,
                        width: { xs: '87px', md: '133px' },
                        height: 'auto',
                    }}
                />
            </Link>
        </Box>
    );
};

export const Logo = observer(LogoComponent);
